export const adjustment_zhCN = {
  'adjustment.members.n01.lbl01': `会员号`,
  'adjustment.members.n01.lbl02': `会员姓名`,
  'adjustment.members.n01.lbl03': `手机号`,
  'adjustment.members.n01.rdo04': `会员等级`,
  'adjustment.members.n01.rdo05': `入会渠道`,
  'adjustment.members.n01.rdo06': `注册开始日期`,
  'adjustment.members.n01.rdo07': `注册结束日期`,
  'adjustment.members.n01.rdo08': `注册门店`,
  'adjustment.members.n01.rdo09': `服务门店`,
  'adjustment.members.n02.btn01': `批量处理`,
  'adjustment.members.n02.btn02': `卡片合并`,
  'adjustment.members.c01.lbl01': `会员号`,
  'adjustment.members.c01.lbl02': `会员姓名`,
  'adjustment.members.c01.lbl03': `手机号`,
  'adjustment.members.c01.lbl04': `性别`,
  'adjustment.members.c01.lbl05': `会员等级`,
  'adjustment.members.c01.lbl06': `可用积分`,
  'adjustment.members.c01.lbl07': `入会渠道`,
  'adjustment.members.c01.lbl08': `注册日期`,
  'adjustment.members.c01.lbl09': `分公司名称`,
  'adjustment.members.c01.lbl10': `注册门店`,
  'adjustment.members.c01.lbl11': `服务门店`,
  'adjustment.members.c01.lbl12': `操作`,
  'adjustment.members.d01.lbl01': `退会确认`,
  'adjustment.members.d01.txt02': `退会操作`,
  'adjustment.members.d01.txt03': `不可逆`,
  'adjustment.members.d01.txt04': `你确定将该会员退会吗？`,

  // 'adjustment.members.c01.lbl18': '转柜',
  // 'adjustment.members.c01.lbl19': '等级调整',
  // 'adjustment.members.c01.lbl20': '积分调整',
  // 'adjustment.members.c01.lbl21': '积分调整',
  'adjustment.members.c01.lbl22': '退会',
  'adjustment.members.inetgral.n02.lbl01': '添加积分管理',
  'adjustment.members.inetgral.n02.lbl02': '积分有效期管理',
  'adjustment.members.inetgral.c01.lbl01': '交易单号',
  'adjustment.members.inetgral.c01.lbl02': '积分',
  'adjustment.members.inetgral.c01.lbl03': '积分过期时间',
  'adjustment.members.inetgral.c01.lbl04': '剩余积分',
  'adjustment.members.inetgral.c02.lbl01': '交易单号',
  'adjustment.members.inetgral.c02.lbl02': '积分',
  'adjustment.members.inetgral.c02.lbl03': '积分过期时间',
  'adjustment.members.inetgral.c02.lbl04': '剩余积分',
  'adjustment.members.inetgral.n03.lbl01': '原剩余积分',
  'adjustment.members.inetgral.n03.rdo02': '调整积分类型',
  'adjustment.members.inetgral.n03.lbl03': '本次调整积分',
  'adjustment.members.inetgral.n03.lbl04': '本次调整原因',
  'adjustment.members.inetgral.n04.lbl01': '原积分过期时间',
  'adjustment.members.inetgral.n04.lbl02': '调整积分过期时间',
  'adjustment.members.inetgral.n04.lbl03': '调整积分有效期原因',
  'adjustment.members.inetgral.n01.rdo01': '请选择调整积分类型',
  'adjustment.members.inetgral.n01.lbl02': '请输入调整积分',
  'adjustment.members.inetgral.n01.lbl03': '请输入调整积分原因',
  'adjustment.members.inetgral.n01.lbl04': '积分调整原因不能为空',
  'adjustment.members.inetgral.n01.rdo05': '请选择某一单',
  'adjustment.members.inetgral.n01.rdo06': '请选择积分调整时间',

  'adjustment.members.level.n02.lbl01': '原会员等级',
  'adjustment.members.level.n02.lbl02': '调整会员等级',
  'adjustment.members.level.n02.lbl03': '调整会员等级原因',
  'adjustment.members.level.n01.rdo01': '请选择调整会员等级',
  'adjustment.members.level.n01.lbl02': '请输入调整会员等级原因',
  'adjustment.members.store.n02.lbl01': '原注册门店',
  'adjustment.members.store.n02.lbl02': '注册门店',
  'adjustment.members.store.n02.lbl03': '请选择门店',
  'adjustment.batch.n01.lbl01': `批量积分调整`,
  'adjustment.batch.n02.btn01': `下载积分模板`,
  'adjustment.batch.n02.btn02': `批量导入积分`,
  'adjustment.batch.c01.lbl01': `编号`,
  'adjustment.batch.c01.lbl02': `会员号`,
  'adjustment.batch.c01.lbl03': `积分变动`,
  'adjustment.batch.c01.lbl04': `积分变动原因`,
  'adjustment.batch.c01.lbl05': `操作人`,
  'adjustment.batch.c01.lbl06': `操作时间`,
  'adjustment.batch.n03.lbl01': `批量转柜调整`,
  'adjustment.batch.n04.btn01': `下载转柜模板`,
  'adjustment.batch.n04.btn02': `批量导入转柜`,
  'adjustment.batch.c02.lbl01': `编号`,
  'adjustment.batch.c02.lbl02': `会员号`,
  'adjustment.batch.c02.lbl03': `转至注册门店`,
  'adjustment.batch.c02.lbl04': `转柜原因`,
  'adjustment.batch.c02.lbl05': `操作人`,
  'adjustment.batch.c02.lbl06': `操作时间`,
  'adjustment.batch.n05.lbl01': `批量等级调整`,
  'adjustment.batch.n06.btn01': `下载等级模板`,
  'adjustment.batch.n06.btn02': `批量导入等级`,
  'adjustment.batch.c03.lbl01': `编号`,
  'adjustment.batch.c03.lbl02': `会员号`,
  'adjustment.batch.c03.lbl03': `等级变动`,
  'adjustment.batch.c03.lbl04': `等级变动原因`,
  'adjustment.batch.c03.lbl05': `操作人`,
  'adjustment.batch.c03.lbl06': `操作时间`,
  'adjustment.members.c01.lbl13': `调整类型`,
  'adjustment.members.c01.lbl14': `调整原因`,
  'adjustment.members.c01.lbl15': `调整时间`,
  'adjustment.members.c01.lbl16': `调整人`,
  'adjustment.members.c01.lbl17': `积分有效期调整`,
  'adjustment.members.c01.lbl18': `转柜`,
  'adjustment.members.c01.lbl19': `等级调整`,
  'adjustment.members.c01.lbl20': `积分调整`,
  'adjustment.members.c01.lbl21': `生日`,
  'adjustment.members.merge.n01.lbl01': `总剩余积分`,
  'adjustment.merge.n01.lbl02': `设为主卡`,
  'adjustment.merge.n01.lbl03': `设为副卡`,
  'adjustment.members.merge.n01.lbl04': `主会员号`,
  'adjustment.members.merge.n01.lbl05': `副会员号`,
  'adjustment.members.merge.n01.lbl06': `会员手机号`,
  'adjustment.members.merge.n01.lbl07': `会员积分`,
  'adjustment.members.merge.n01.lbl08': `卡号合并原因`,
  'adjustment.members.merge.n01.lbl09': `请设置副卡号`,
  'adjustment.members.merge.n01.lbl10': `请输入卡号合并原因`,
  'adjustment.merge.n01.lbl11': `合并会员号确认`,
  'adjustment.merge.n01.lbl12': `会员卡号`,
  'adjustment.merge.n01.lbl13': `合并后不可逆，被合并的卡号将被注销`,
  'adjustment.merge.n01.lbl14': `您确定要合并会员卡号吗？`,
  'adjustment.merge.n01.lbl15': `确定`,
  'adjustment.members.merge.n01.lbl16': `请设置主卡号`,
  'adjustment.merge.n01.lbl17': `卡号合并成功`,
};

export const adjustment_enUS = {
  'adjustment.members.n01.lbl01': `MEMBER ID`,
  'adjustment.members.n01.lbl02': `MEMBER NAME`,
  'adjustment.members.n01.lbl03': `MP NUMBER`,
  'adjustment.members.n01.rdo04': `RANK`,
  'adjustment.members.n01.rdo05': `SOURCE OF REGISTRATION`,
  'adjustment.members.n01.rdo06': `START OF DATE OF REGISTRATION`,
  'adjustment.members.n01.rdo07': `END OF DATE OF REGISTRATION`,
  'adjustment.members.n01.rdo08': `STORE OF REGISTRATION`,
  'adjustment.members.n01.rdo09': `STORE OF ACTIVE`,
  'adjustment.members.n02.btn01': `BATCH ADJUSTMENT`,
  'adjustment.members.c01.lbl18': `CHANGE STORE`,
  'adjustment.members.n02.btn02': `CARD MERGING`,
  'adjustment.members.c01.lbl01': `MEMBER ID`,
  'adjustment.members.c01.lbl02': `MEMBER NAME`,
  'adjustment.members.c01.lbl03': `MP NUMBER`,
  'adjustment.members.c01.lbl04': `GENDER`,
  'adjustment.members.c01.lbl05': `RANK`,
  'adjustment.members.c01.lbl06': `POINTS AVAILABLE`,
  'adjustment.members.c01.lbl07': `SOURCE OF REGISTRATION`,
  'adjustment.members.c01.lbl08': `DATE OF REGISTRATION`,
  'adjustment.members.c01.lbl09': `NAME OF SUBSIDIARY`,
  'adjustment.members.c01.lbl10': `STORE OF REGISTRATION`,
  'adjustment.members.c01.lbl11': `STORE OF ACTIVE`,
  'adjustment.members.c01.lbl12': `ACTION`,
  'adjustment.members.d01.lbl01': `退会确认`,
  'adjustment.members.d01.txt02': `退会操作`,
  'adjustment.members.d01.txt03': `不可逆`,
  'adjustment.members.d01.txt04': `你确定将该会员退会吗？`,
  'adjustment.members.store.n02.lbl01': 'Original store of registration',
  'adjustment.members.store.n02.lbl03': 'Please enter store name',
  'adjustment.members.inetgral.n01.rdo01': 'Please Choose Points Changing Type',
  'adjustment.members.inetgral.n01.lbl02': 'Please Enter Changing Points',
  'adjustment.members.inetgral.n01.lbl03': 'Please Enter Reason',
  'adjustment.members.inetgral.n01.lbl04': 'Reason must be filled',
  'adjustment.members.inetgral.n01.rdo05': 'Please Choose Order',
  'adjustment.members.inetgral.n01.rdo06':
    'adjustment.members.inetgral.n01.lbl03',

  'adjustment.members.inetgral.n02.lbl01': 'Add Points Management',
  'adjustment.members.inetgral.n02.lbl02': 'Points Valid Period Management',
  'adjustment.members.inetgral.c01.lbl01': 'Order ID',
  'adjustment.members.inetgral.c01.lbl02': 'Points',
  'adjustment.members.inetgral.c01.lbl03': 'Points Expiration Date',
  'adjustment.members.inetgral.c01.lbl04': 'Remaining Points',
  'adjustment.members.inetgral.c02.lbl01': 'Order ID',
  'adjustment.members.inetgral.c02.lbl02': 'Points',
  'adjustment.members.inetgral.c02.lbl03': 'Points Expiration Date',
  'adjustment.members.inetgral.c02.lbl04': 'Remaining Points',
  'adjustment.members.inetgral.n03.lbl01': 'Original Remaining Points',
  'adjustment.members.inetgral.n03.rdo02': 'Change Points Type',
  'adjustment.members.inetgral.n03.lbl03': 'Points Changing',
  'adjustment.members.inetgral.n03.lbl04': 'Change Reason',
  'adjustment.members.inetgral.n04.lbl01': 'Original Time of Expiration',
  'adjustment.members.inetgral.n04.lbl02': 'Change Time of Expiration',
  'adjustment.members.inetgral.n04.lbl03': 'Change reason',
  'adjustment.members.level.n01.rdo01': 'Please Choose Changing Level',
  'adjustment.members.level.n01.lbl02': 'Please Enter Reason',
  'adjustment.members.level.n02.lbl01': 'Original Member Level',
  'adjustment.members.level.n02.lbl02': 'Change Level to',
  'adjustment.members.level.n02.lbl03': 'Change Reason',
  // 'adjustment.members.store.n02.lbl01': '原注册门店',
  'adjustment.members.store.n02.rdo02': 'Store of registration',
  'adjustment.batch.n01.lbl01': `BATCH POINTS ADJUSTMENT`,
  'adjustment.batch.n02.btn01': `DOWNLOAD POINTS TEMPLET`,
  'adjustment.batch.n02.btn02': `BATCH POINTS IMPORT`,
  'adjustment.batch.c01.lbl01': `SERIAL NUMBER`,
  'adjustment.batch.c01.lbl02': `MEMBER ID`,
  'adjustment.batch.c01.lbl03': `POINTS CHANGED`,
  'adjustment.batch.c01.lbl04': `REASON`,
  'adjustment.batch.c01.lbl05': `OPERATOR`,
  'adjustment.batch.c01.lbl06': `OPERATED TIME`,
  'adjustment.batch.n03.lbl01': `BATCH COUNTERS ADJUSTMENT`,
  'adjustment.batch.n04.btn01': `DOWNLOAD COUNTERS TEMPLET`,
  'adjustment.batch.n04.btn02': `BATCH COUNTERS IMPORT`,
  'adjustment.batch.c02.lbl01': `SERIAL NUMBER`,
  'adjustment.batch.c02.lbl02': `MEMBER ID`,
  'adjustment.batch.c02.lbl03': `STORE OF ACTIVE CHANGED TO`,
  'adjustment.batch.c02.lbl04': `REASON`,
  'adjustment.batch.c02.lbl05': `OPERATOR`,
  'adjustment.batch.c02.lbl06': `OPERATED TIME`,
  'adjustment.batch.n05.lbl01': `BATCH RANK ADJUSTMENT`,
  'adjustment.batch.n06.btn01': `DOWNLOAD RANK TEMPLET`,
  'adjustment.batch.n06.btn02': `BATCH RANK IMPORT`,
  'adjustment.batch.c03.lbl01': `SERIAL NUMBER`,
  'adjustment.batch.c03.lbl02': `MEMBER ID`,
  'adjustment.batch.c03.lbl03': `RANK CHANGED TO`,
  'adjustment.batch.c03.lbl04': `REASON`,
  'adjustment.batch.c03.lbl05': `OPERATOR`,
  'adjustment.batch.c03.lbl06': `OPERATED TIME`,
  // 'adjustment.members.c01.lbl13': ``, //调整类型
  'adjustment.members.c01.lbl13': `CHANGE TYPE`, //调整类型
  'adjustment.members.c01.lbl14': `CHANGE REASON`, //调整原因
  'adjustment.members.c01.lbl15': `CHANGE TIME`, //调整时间
  'adjustment.members.c01.lbl16': `OPERATOR`, //调整人
  'adjustment.members.c01.lbl17': ``, //积分有效期调整
  // 'adjustment.members.c01.lbl18': ``, //转柜
  'adjustment.members.c01.lbl19': `LEVEL CHANGE`, //等级调整
  'adjustment.members.c01.lbl20': `POINTS CHANGE`, //积分调整
  'adjustment.members.c01.lbl21': `BIRTHDAY`, //生日
  'adjustment.members.merge.n01.lbl01': `REMAINING POINTS`, //总剩余积分
  'adjustment.merge.n01.lbl02': ``, //设为主卡
  'adjustment.merge.n01.lbl03': ``, //设为副卡
  'adjustment.members.merge.n01.lbl04': `MAIN MEMBER ID`, //主会员号
  'adjustment.members.merge.n01.lbl05': `SUB MEMBER ID`, //副会员号
  'adjustment.members.merge.n01.lbl06': `MEMBER MP NUMBER`, //会员手机号
  'adjustment.members.merge.n01.lbl07': `MEMBER POINTS`, //会员积分
  'adjustment.merge.n01.lbl07': ``,
  'adjustment.members.merge.n01.lbl08': `MERGE REASON`, //卡号合并原因
  'adjustment.members.merge.n01.lbl09': `PLEASE SET SUB CARD ID`, //请设置副卡号
  'adjustment.members.merge.n01.lbl10': `PLEASE ENTER MERGE REASON`, //请输入卡号合并原因
  'adjustment.merge.n01.lbl11': ``, //合并会员号确认
  'adjustment.merge.n01.lbl12': ``, //会员卡号
  'adjustment.merge.n01.lbl13': ``, //合并后不可逆，被合并的卡号将被注销
  'adjustment.merge.n01.lbl14': ``, //您确定要合并会员卡号吗？
  'adjustment.merge.n01.lbl15': ``, //确定
  'adjustment.members.merge.n01.lbl16': `PLEASE SET MAIN CARD ID`, //请设置主卡号
  'adjustment.merge.n01.lbl17': ``, //卡号合并成功
};
